import styled from 'styled-components';

const MessageTypesContentWrapper = styled.div`
  .section-title {
    margin: 0;
    font-size: 1.1em;
  }
  .message-types-row {
    padding: 1.5em 1em .5em;  
    display: flex;
    align-items: center;
    justify-content: space-between;
    >label {
      width: initial;
      min-width: 25%;
    }    
  }
  .input-el-row {
    margin-top: 1em;
    .input-label {
      font-size: 0.875em;
      margin-bottom: 0;
      color: ${p => p.theme.color.label};
    }
    .select {
      margin-bottom: 0;
    }
  } 
  .scrolled{
    overflow: auto;
    max-height: calc(95vh -  64px - 104px - 71px);
    min-height: 180px;
    position: relative;
    &>.border-bottom {
      border-bottom: 1px solid ${p => p.theme.color.border};
      &:last-child {
        border-bottom: none;
      }
    }
  } 
  .footer {
    justify-content: flex-end;
  }  
`;


export default {
  MessageTypesContentWrapper
};